import { Button } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
    background: #fff;
    box-shadow: 1px 2px 6px 0px rgba(37, 62, 145, 0.17);
    border-radius: 3px;
    min-height: 36px;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    overflow: auto;

    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        border-radius: 100px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 100px;
    }

    ::-webkit-scrollbar-thumb {
        background: rgb(200, 200, 200);
        border-radius: 100px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: rgb(175, 175, 175);
        border-radius: 100px;
    }
`;

export const TextContainer = styled.div`
    color: ${({ selected }) => (selected ? "#ff8d6a" : "#b1b1b1")};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
    text-decoration: ${({ disabled }) => (disabled ? "line-through" : "none")};
    font-weight: 600;
    font-family:
        Hind Vadodara,
        Lucida Sans Unicode !important;
    font-size: 15px;
    letter-spacing: 0.8px;
    border-right: 2px dotted rgb(172, 180, 185);
    display: flex;
    align-items: center;
    padding: 10px;
    height: 20px;
    cursor: pointer;
`;

export const CatalogListDropdownButton = styled(Button)`
    &&{
        background-color: #f2f2f2;
        color: #666;
        text-transform: none;
        border-radius: 20px;
        box-shadow: none;
        min-width: 130px;
        font-weight: 600;
        &:hover{
            background-Color: #e6e6e6;
            box-shadow: none,
        },
    }
`;
